//Quick and Dirty
declare var require: any

import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { RebateRequestMeasurementCommitteeDecisionComponent } from '../rebate-request-measurement-committee-decision/rebate-request-measurement-committee-decision.component';
import { LongHaulRequestOption, LongHaulRequest, OptionKey, LongHaulOptionRebate, LongHaulDefineRebate, LongHaulRequestAccurateDataForm, LongHaulRequestMeasurementCommitteeAccept, LongHaulRequestMeasurementCommitteeDecision } from 'src/app/shared/models/long-haul.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Router } from '@angular/router';
import { ErrorsEnum, SCAWaterMark } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { VesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
import { DatePipe } from '@angular/common';

//import { Direct } from 'protractor/built/driverProviders';
import { EventTarget } from 'ngx-bootstrap/utils/facade/browser';
import { ETenderViewAllFieldsDTO } from 'src/app/shared/models/e-tender.model';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import * as pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

@Component({
  selector: 'app-rebate-request-define-rebate',
  templateUrl: './rebate-request-define-rebate.component.html'
})

export class RebateRequestDefineRebateComponent implements OnInit {
  @ViewChild('pdfTable', { static: false }) pdfTable: ElementRef;
  //#region Properties & Variables
  //Submit Properties
  public isRequestSucceeded: boolean = false;
  //Rebate Request Properties
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest', { static: false }) rebateRequest: RebateRequestComponent;
  @ViewChild('measurementCommitteeDecision', { static: false }) measurementCommitteeDecision: RebateRequestMeasurementCommitteeDecisionComponent;
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private selectedLongHaulRequestOption: LongHaulRequestOption = new LongHaulRequestOption();
  private selectedLongHaulRequestOptionLoaded: LongHaulOptionRebate = new LongHaulOptionRebate();
  public currentSelctedOption: string = null;
  private ports: Port[] = [];
  public ParentRequestLoaded: LongHaulRequest = new LongHaulRequest();
  private getRebateRequestResponseObject: ResponseObject = new ResponseObject();
  private countries: Country[] = [];
  private rates: GenericLookup[] = [];
  private lastPortOriginsArr: OptionKey[] = [];
  private firstPortDestinationsArr: OptionKey[] = [];
  //Options Properties
  public isOptionDetailsSelected: boolean = false;
  private optionSelectedText: string = "";
  //Define Rebate Array
  private optionsRebate: LongHaulOptionRebate[] = [];
  private optionsArrayIndex: number = 0;
  //Submit Properties
  private isOptionSubmitted: boolean = false;
  private isOptionRebatePercentageValid: boolean = true;
  private isFormSubmitted: boolean = false;
  public isOptionsRebateArrNotValid: boolean = false;
  private defineOptionsRebateResponseObject: ResponseObject = new ResponseObject();
  //New / Display [Mode]
  private formMode: FormMode;
  public ParentCreationDate;
  private decision: Decision;
  private standardMessage: string = "This Request is rejected, please submit new request if needed";
  //Define Rebate Request
  private longHaulDefineRebate: LongHaulDefineRebate = new LongHaulDefineRebate();
  //Event Properties
  @Output() defineRebateLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  @Output() optionSelected: EventEmitter<string> = new EventEmitter();
  //Review Rebate Component
  public isReviewRebateAdmin: boolean = false;
  //Parent Components Loading
  // private noOfLoadedComponents: number = 0;
  // private noOfComponentsToLoad: number = 2;
  public longHaulRequestMeasurementCommitteeDecision: LongHaulRequestMeasurementCommitteeDecision = new LongHaulRequestMeasurementCommitteeDecision();
  public longHaulRequestMeasurementCommitteeAccept: LongHaulRequestMeasurementCommitteeAccept = new LongHaulRequestMeasurementCommitteeAccept();
  private getDefineRebateRequest: LongHaulDefineRebate = new LongHaulDefineRebate();
  private getDefineRebateRequestResponseObject: ResponseObject = new ResponseObject();
  public getDefineRebateResponse: LongHaulDefineRebate = new LongHaulDefineRebate();
  private getMeasurementAcceptedRebateRequestResponseObject: ResponseObject = new ResponseObject();
  public isDefineRebateComponent: boolean = true;
  private currentRebatePercentage: number = 0;
  public isUpdateRebatePercentageNotValid: boolean = false;
  //User Properties
  public currentUser: User = new User();
  private addOptionPercentageBtnTxt: string = "Add Option Rebate Percentage";
  //Submit Properties
  private isSubmitValid: boolean = true;
  //Update Percentage
  private noOfOptionsDone: number = 0;
  private agentFax: string = "";
  //Review Rebate Component
  private reviewRebateSectionTitle: string = "Measurement Review Rebate Decision";
  //Export Excel
  private exportOptionsExcelResponseObject: ResponseObject = new ResponseObject();
  //Accurate Data Form
  private getAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private getAccurateDataFormObject: LongHaulRequestAccurateDataForm;
  private isAccurateDataForm: boolean = false;
  private accurateDataFormDateOfSailing: Date;
  //Loading Components
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 2;
  private isNegativeNumber: boolean = false;
  private isrestudy: boolean = false;
  //Request History
  public vesselTypes: GenericLookup[] = [];

  private isRequestHistoryComponent: boolean = false;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private agentSrv: AgentService, private lookupService: LookupService, public datepipe: DatePipe, private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
    if (history.state.data && history.state.data.isCompleted) {
      this.isRequestHistoryComponent = true;
    }
  }

  ngOnInit() {
    //Enable Loader
    this.loadVesselTypes();
    this.loadRates();

    this.globalServices.isLoaderEnabled = true;
    if (window.location.href.indexOf('/RebateRequest/ReviewRebate') > -1)
      this.reviewRebateSectionTitle = "Measurement Review Rebate Previous Decision";
  }
  getAgentOnly(requestorId) {
    this.agentSrv.GetAgentOnly(requestorId).subscribe(d => {
      if (d.Success) {

        this.agentFax = d.Data.Fax;
      }
    });
  }
  loadRates(): void {
    this.lookupService.getRates().subscribe(
      data => this.rates = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),

    );
  }
  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadVesselTypesCompleted()
    );
  }

  loadVesselTypesCompleted(): void {
    let otherVesselType: VesselType = this.vesselTypes.filter(v => v.NameEN == 'Other Vessel')[0];
    this.vesselTypes = this.vesselTypes.filter(v => v.NameEN != 'Other Vessel');
    this.vesselTypes.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.vesselTypes.push(otherVesselType);
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if (flag) {
      this.getAgentOnly(this.rebateRequest.rebateRequestLoaded.BaseRequest.RequestorId);
      this.isrestudy = this.rebateRequest.rebateRequestLoaded.IsRestudy;
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      if (this.rebateRequest.rebateRequestLoaded.ParentRequestNumber) {
        this.LaodParentData(this.rebateRequest.rebateRequestLoaded.BaseRequest.ParentRequestId);
      }
      this.loadMeasurementDecisionRebateRequest();
      this.rebateRequest.editModeAdmin = true;

      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.ports = this.rebateRequest.ports;
      this.countries = this.rebateRequest.countries;
      this.fillPortsDictionary();
      if (this.rebateRequest.rebateRequestLoaded.LongHaulRequestMeasurementCommittee.DecisionId == Decision.Accept) {
        this.formMode = FormMode.MeasurementDetailsAccept;
        this.longHaulDefineRebate.DecisionId = Decision.Accept;
      } else if (this.rebateRequest.rebateRequestLoaded.LongHaulRequestMeasurementCommittee.DecisionId == Decision.Reject) {
        this.formMode = FormMode.MeasurementDetailsReject;
        this.longHaulDefineRebate.DecisionId = Decision.Reject;
        this.isFormSubmitted = true;
      }
      //this.setDefaults();
      this.checkLoadedComponents();
    }
  }
  onMeasurementCommitteeDecisionLoadedFlag(flag: boolean) {
    this.measurementCommitteeDecision.isDefineRebateAdmin = true;
    // if(flag){
    //   this.measurementCommitteeDecision.isDefineRebateAdmin = true;
    //   if(this.measurementCommitteeDecision.formMode == 3) {
    //     //this.timeout();
    //     this.formMode = FormMode.MeasurementDetailsAccept;
    //     this.longHaulDefineRebate.DecisionId = Decision.Accept;
    //   } else if(this.measurementCommitteeDecision.formMode == 4) {
    //     //this.timeout();
    //     this.formMode = FormMode.MeasurementDetailsReject;
    //     this.longHaulDefineRebate.DecisionId = Decision.Reject;
    //     this.isFormSubmitted = true;
    //   }
    //   this.checkLoadedComponents();
    // }
  }
  checkLoadedComponents(): void {
    // this.noOfLoadedComponents++;
    // if(this.noOfLoadedComponents == this.noOfComponentsToLoad){
    this.getDefineRebateRequest.LongHaulRequestId = this.rebateRequestId;
    this.getDefineRebateRequest.DecisionId = this.longHaulDefineRebate.DecisionId;
    this.getDefineRebateRequest.LongHaulOptionsRebate = [];
    if (this.longHaulDefineRebate.DecisionId == Decision.Accept) {
      for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
        this.getDefineRebateRequest.LongHaulOptionsRebate[i] = new LongHaulOptionRebate();
        this.getDefineRebateRequest.LongHaulOptionsRebate[i].Id = this.longHaulRequestOptions[i].Id;
      }
    }
    this.getDefineRebate();
    this.getAccurateDataForm();
    // }
  }
  // setDefaults(): void {
  //   //Enable Loader
  //   this.globalServices.isLoaderEnabled = true;
  //   this.getDefineRebateRequest.LongHaulRequestId = this.rebateRequestId;
  //   this.getDefineRebateRequest.DecisionId = this.longHaulDefineRebate.DecisionId;
  //   this.getDefineRebateRequest.LongHaulOptionsRebate = [];
  //   for(let i: number = 0; i < this.longHaulRequestOptions.length; i++){
  //     this.getDefineRebateRequest.LongHaulOptionsRebate[i] = new LongHaulOptionRebate();
  //     this.getDefineRebateRequest.LongHaulOptionsRebate[i].Id = this.longHaulRequestOptions[i].Id;
  //   }
  //   this.getDefineRebate();
  // }
  getDefineRebate(): void {
    this.longHaulService.getDefineRebate(this.getDefineRebateRequest).subscribe(
      data => this.getDefineRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getDefineRebateCompleted()
    );
  }
  getDefineRebateCompleted(): void {
    if (this.getDefineRebateRequestResponseObject.Success) {
      this.getDefineRebateResponse = this.getDefineRebateRequestResponseObject.Data as LongHaulDefineRebate;
      if (this.getDefineRebateResponse.LongHaulOptionsRebate.length > 0) {
        //this.timeout();
        if (this.getDefineRebateResponse.LongHaulOptionsRebate[0].MeasurementDecisionId == null || this.isRequestHistoryComponent) {
          this.formMode = FormMode.Details;
        } else {
          this.addOptionPercentageBtnTxt = "Update Option Rebate Percentage";
          this.formMode = FormMode.DetailsUpdate;
        }
        for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
          if (this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].MeasurementDecisionId == Decision.Accept) {
            this.longHaulRequestOptions[i].IsOptionAdminDone = true;
            this.noOfOptionsDone++;
          }
          if (+this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].RebatePercentage == 0)
            this.longHaulRequestOptions[i].RebatePercentageLetters = "Zero";
          else if (this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].RebatePercentage == "-" || this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].RebatePercentage == "--")
            this.longHaulRequestOptions[i].RebatePercentageLetters = "No Rebate";
          else
            this.longHaulRequestOptions[i].RebatePercentageLetters = this.convertNumsToWords(this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].RebatePercentage);
          this.longHaulRequestOptions[i].DisplayedDefinedRebate = this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.longHaulRequestOptions[i].Id)[0].RebatePercentage;
        }
      }
      this.checkLoading();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  fillPortsDictionary(): void {
    for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
      this.lastPortOriginsArr[i] = new OptionKey();
      this.lastPortOriginsArr[i].Index = i;
      this.lastPortOriginsArr[i].Text = this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].LastPortOriginId)[0] != undefined ? this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].LastPortOriginId)[0].NameEN : this.longHaulRequestOptions[i].OtherLastPortOrigin;
      this.lastPortOriginsArr[i].Value = this.longHaulRequestOptions[i].LastPortOriginId;
      this.firstPortDestinationsArr[i] = new OptionKey();
      this.firstPortDestinationsArr[i].Index = i;
      this.firstPortDestinationsArr[i].Text = this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].FirstPortDestinationId)[0] != undefined ? this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].FirstPortDestinationId)[0].NameEN : this.longHaulRequestOptions[i].OtherFirstPortDestination;
      this.firstPortDestinationsArr[i].Value = this.longHaulRequestOptions[i].LastPortOriginId;
      this.longHaulRequestOptions[i].NumericSuggestedRebate = +this.longHaulRequestOptions[i].SuggestedRebate;
    }
  }
  onOptionChange(event): void {


    let selectedOptions = event.target['options'];
    let selectedIndex = selectedOptions.selectedIndex;
    this.optionSelectedText = selectedOptions[selectedIndex].text;
    if (this.currentSelctedOption != "null") {
      this.isOptionDetailsSelected = true;
      this.selectedLongHaulRequestOption = this.longHaulRequestOptions.filter(o => o.Id == this.currentSelctedOption)[0];

      this.selectedLongHaulRequestOption.DateOfSailing = this.datepipe.transform(this.selectedLongHaulRequestOption.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
      this.selectedLongHaulRequestOption.ETA = this.datepipe.transform(this.selectedLongHaulRequestOption.ETA.split("T")[0], 'dd-MM-yyyy');

      if (this.selectedLongHaulRequestOption.LastPortOriginId == null)
        this.selectedLongHaulRequestOption.LastPortOriginId = -1;
      if (this.selectedLongHaulRequestOption.FirstPortDestinationId == null)
        this.selectedLongHaulRequestOption.FirstPortDestinationId = -1;

      if (this.formMode == FormMode.Details || this.formMode == FormMode.DetailsUpdate) {
        this.selectedLongHaulRequestOptionLoaded = this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0];
        this.selectedLongHaulRequestOption.RebatePercentage = this.selectedLongHaulRequestOptionLoaded.RebatePercentage.toString();
        if (!this.selectedLongHaulRequestOption.IsOptionAdminDone)
          this.currentRebatePercentage = +this.selectedLongHaulRequestOptionLoaded.RebatePercentage;
        this.selectedLongHaulRequestOption.EconomicCommiteeDefineRebateNotes = this.selectedLongHaulRequestOptionLoaded.Notes;
        this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = this.selectedLongHaulRequestOptionLoaded.MeasurementDecisionId == Decision.Accept ? "Accepted" : "Rejected";
        this.selectedLongHaulRequestOption.IsUpdatePercentageEnabled = this.selectedLongHaulRequestOptionLoaded.MeasurementDecisionId == Decision.Reject ? true : false;
        this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = this.selectedLongHaulRequestOptionLoaded.MeasurementRejectionReason;
        this.optionSelected.emit(this.selectedLongHaulRequestOption.Id);
      }
    } else {
      this.isOptionDetailsSelected = false;
      this.selectedLongHaulRequestOption = new LongHaulRequestOption();
      this.selectedLongHaulRequestOptionLoaded = new LongHaulOptionRebate();
      if (this.formMode == FormMode.Details || this.formMode == FormMode.DetailsUpdate) {
        this.optionSelected.emit("");
      }
    }
    this.isOptionsRebateArrNotValid = false;
  }
  rebatePercentageChange(event): void {
    //if(!this.checkUpdatedRebatePercentage()){
    const numWords = require('num-words');
    let rebatePercentageLettersArr: string[] = [];
    // ** All Cases
    // [Zero]
    // [-]
    // [--]
    // Negative Number
    // Normal Number

    // [Zero]
    if (this.selectedLongHaulRequestOption.RebatePercentage != undefined) {
      if (+this.selectedLongHaulRequestOption.RebatePercentage == 0) {
        this.isNegativeNumber = false;
        this.selectedLongHaulRequestOption.RebatePercentageLetters = "Zero";
      } // Negative Number || Number Nrgative
      else if (+this.selectedLongHaulRequestOption.RebatePercentage < 0 || (!isNaN(+this.selectedLongHaulRequestOption.RebatePercentage[0]) && this.selectedLongHaulRequestOption.RebatePercentage[1] == '-')) {
        this.isNegativeNumber = true;
        this.selectedLongHaulRequestOption.RebatePercentageLetters = "Not Valid";
      } // Normal Number
      else if (this.selectedLongHaulRequestOption.RebatePercentage != undefined && !isNaN(+this.selectedLongHaulRequestOption.RebatePercentage) && +this.selectedLongHaulRequestOption.RebatePercentage > 0) {
        if (this.selectedLongHaulRequestOption.RebatePercentage == "13.5") {
          this.selectedLongHaulRequestOption.RebatePercentageLetters = "Thirteen and a half";
        }
        else {
          this.isNegativeNumber = false;
          rebatePercentageLettersArr = numWords(this.selectedLongHaulRequestOption.RebatePercentage).split(' ');
          this.selectedLongHaulRequestOption.RebatePercentageLetters = "";
          for (let i: number = 0; i < rebatePercentageLettersArr.length; i++) {
            rebatePercentageLettersArr[i] = rebatePercentageLettersArr[i].charAt(0).toUpperCase() + rebatePercentageLettersArr[i].slice(1);
            this.selectedLongHaulRequestOption.RebatePercentageLetters += rebatePercentageLettersArr[i];
            if (i != rebatePercentageLettersArr.length - 1)
              this.selectedLongHaulRequestOption.RebatePercentageLetters += " ";
          }
          if (+this.selectedLongHaulRequestOption.RebatePercentage > this.selectedLongHaulRequestOption.NumericSuggestedRebate) {
            this.isOptionRebatePercentageValid = false;
          } else {
            this.isOptionRebatePercentageValid = true;
          }
        }
      } // [-] & [--]
      else {
        this.isNegativeNumber = false;
        this.selectedLongHaulRequestOption.RebatePercentageLetters = "No Rebate";
      }
    }
    else {
      this.selectedLongHaulRequestOption.RebatePercentage = "";
    }
    //}
  }
  addOptionRebatePercentage(): void {
    if (!this.checkUpdatedRebatePercentage()) {
      let checkOptionAdded = this.optionsRebate.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0];
      if (checkOptionAdded == undefined) {
        this.optionsRebate[this.optionsArrayIndex] = new LongHaulOptionRebate();
        this.optionsRebate[this.optionsArrayIndex].Id = this.selectedLongHaulRequestOption.Id;
        this.optionsRebate[this.optionsArrayIndex].RebatePercentage = this.selectedLongHaulRequestOption.RebatePercentage;
        this.optionsRebate[this.optionsArrayIndex].Notes = this.selectedLongHaulRequestOption.EconomicCommiteeDefineRebateNotes;
        this.optionsArrayIndex++;
      } else {
        checkOptionAdded.RebatePercentage = this.selectedLongHaulRequestOption.RebatePercentage;
        checkOptionAdded.Notes = this.selectedLongHaulRequestOption.EconomicCommiteeDefineRebateNotes;
      }
      this.longHaulRequestOptions.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0].DisplayedDefinedRebate = this.selectedLongHaulRequestOption.RebatePercentage.toString();
      this.isFormSubmitted = true;
      this.isOptionDetailsSelected = false;
      this.currentSelctedOption = "null";
      this.isOptionSubmitted = false;
      this.isOptionsRebateArrNotValid = false;
      if (this.formMode == FormMode.DetailsUpdate) {
        this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0].RebatePercentage = this.selectedLongHaulRequestOption.RebatePercentage;
        this.getDefineRebateResponse.LongHaulOptionsRebate.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0].Notes = this.selectedLongHaulRequestOption.EconomicCommiteeDefineRebateNotes;
      }
      this.longHaulRequestOptions.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0].IsOptionAdminDone = true;
      const el = document.getElementById('ddlOptions');
      el.scrollIntoView({ behavior: 'smooth' });
      this.isNegativeNumber = false;
    }
  }
  submit(): void {
    if (this.longHaulDefineRebate.DecisionId == Decision.Accept) {
      if ((this.formMode == FormMode.MeasurementDetailsAccept && this.longHaulRequestOptions.length != this.optionsRebate.length) || (this.formMode == FormMode.DetailsUpdate && this.longHaulRequestOptions.length != (this.optionsRebate.length + this.noOfOptionsDone))) {
        this.isOptionsRebateArrNotValid = true;
        const el = document.getElementById('ddlOptions');
        el.focus();
        this.isSubmitValid = false;
      } else {
        this.longHaulDefineRebate.LongHaulOptionsRebate = this.optionsRebate;
        this.isSubmitValid = true;
      }
    } else if (this.longHaulDefineRebate.DecisionId == Decision.Reject) {
      this.longHaulDefineRebate.StandardMessage = this.standardMessage;
    }
    if (this.isSubmitValid) {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.longHaulDefineRebate.LongHaulRequestId = this.rebateRequestId;
      this.longHaulDefineRebate.EconomicCommitteeAdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      //this.longHaulDefineRebate.EconomicCommitteeAdminEmail = "Nada.Alaskari@linkdev.com";
      if (this.formMode == FormMode.MeasurementDetailsAccept || this.formMode == FormMode.MeasurementDetailsReject)
        this.defineOptionsRebate();
      else if (this.formMode == FormMode.DetailsUpdate)
        this.editDefineOptionsRebate();
    }
  }
  defineOptionsRebate(): void {
    this.longHaulService.defineRebate(this.longHaulDefineRebate).subscribe(
      data => this.defineOptionsRebateResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.defineOptionsRebateCompleted()
    );
  }
  defineOptionsRebateCompleted(): void {
    // Enable Error
    if (!this.defineOptionsRebateResponseObject.Success) {
      //Enable Error / Warning
      if (this.defineOptionsRebateResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.defineOptionsRebateResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Enable Confirmation
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  editDefineOptionsRebate(): void {
    this.longHaulService.editDefineRebate(this.longHaulDefineRebate).subscribe(
      data => this.defineOptionsRebateResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.defineOptionsRebateCompleted()
    );
  }
  // timeout() {
  //   var that = this;
  //   setTimeout(function () {
  //     that.timeout();
  //   }, 10000);
  // }
  checkUpdatedRebatePercentage(): boolean {
    let result = false;
    // if(this.formMode == FormMode.DetailsUpdate){
    //   if(this.currentRebatePercentage == this.selectedLongHaulRequestOption.RebatePercentage){
    //     this.isUpdateRebatePercentageNotValid = true;
    //     result = true;
    //   } else {
    //     this.isUpdateRebatePercentageNotValid = false;
    //   }
    // }
    result = this.isNegativeNumber;
    return result;
  }
  //Cancel
  // public cancelAddingPercentage(): void {
  //   this.isOptionDetailsSelected = false;
  //   this.selectedLongHaulRequestOption.RebatePercentage = null;
  //   this.selectedLongHaulRequestOption.EconomicCommiteeDefineRebateNotes = "";
  //   this.selectedLongHaulRequestOption = new LongHaulRequestOption();
  //   this.selectedLongHaulRequestOptionLoaded = new LongHaulOptionRebate();
  //   this.currentSelctedOption = "null";
  //   const el = document.getElementById('divLongHaulRequestOptions');
  //   el.scrollIntoView({behavior:'smooth'});
  // }
  convertNumsToWords(number): string {
    if (number == "13.5") {
      return "Thirteen and a half";
    }
    else if (number % 1 == 0) {
      let numToWords: string = "";
      const numWords = require('num-words');
      let num = number.replace(/\s/g, "");
      let rebatePercentageLettersArr: string[] = numWords(num).split(' ');
      for (let i: number = 0; i < rebatePercentageLettersArr.length; i++) {
        rebatePercentageLettersArr[i] = rebatePercentageLettersArr[i].charAt(0).toUpperCase() + rebatePercentageLettersArr[i].slice(1);
        numToWords += rebatePercentageLettersArr[i];
        if (i != rebatePercentageLettersArr.length - 1)
          numToWords += " ";
      }
      return numToWords;
    }
    else {
      return "";
    }
  }
  LaodParentData(parentID): void {
    this.longHaulService.getRebateRequest(parentID).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestCompleted()
    );
  }
  getRebateRequestCompleted(): void {
    if (this.getRebateRequestResponseObject.Success) {

      this.ParentRequestLoaded = this.getRebateRequestResponseObject.Data as LongHaulRequest;
      this.ParentCreationDate = this.ParentRequestLoaded.BaseRequest.CreationDate;
    }
  }
  loadMeasurementDecisionRebateRequest(): void {
    this.longHaulService.getMeasurementDecisionRebateRequest(this.rebateRequestId).subscribe(
      data => this.getMeasurementAcceptedRebateRequestResponseObject = data,
      () => this.loadMeasurementDecisionRebateRequestfail(),
      () => this.loadMeasurementDecisionRebateRequestCompleted()
    );
  }
  loadMeasurementDecisionRebateRequestfail(): void {
    this.longHaulRequestMeasurementCommitteeDecision = null;
    this.longHaulRequestMeasurementCommitteeAccept = null;
  }
  loadMeasurementDecisionRebateRequestCompleted(): void {

    if (this.getMeasurementAcceptedRebateRequestResponseObject.Success) {

      this.longHaulRequestMeasurementCommitteeDecision = this.getMeasurementAcceptedRebateRequestResponseObject.Data as LongHaulRequestMeasurementCommitteeDecision;
      this.longHaulRequestMeasurementCommitteeAccept = this.longHaulRequestMeasurementCommitteeDecision.LongHaulRequestMeasurementCommitteeAccept;
    } else {
      this.longHaulRequestMeasurementCommitteeDecision = null;
      this.longHaulRequestMeasurementCommitteeAccept = null;
    }
  }
  PrintCover(e): void {
    e.preventDefault();
    this.PrintCoverToPDF();
  }
  MeasurementExport(e): void {
    e.preventDefault();
    //this.MeasurementExportToPDF();
  }
  PrintCoverToPDF(): void {
    let AccurateDataFormRemarks = '';

    if (this.getAccurateDataFormObject != null) {
      AccurateDataFormRemarks = 'Accurate Data Form Remarks: ' + this.getAccurateDataFormObject.Remarks;
    }
    let Background = SCAWaterMark.Background;
    let SCNT;
    let NotesAndComments;
    let DW;
    let ratelTypeName;
    let ParentNumber = '';
    let vesselTypeName;
    if (this.rebateRequest.rebateRequestLoaded.ParentRequestNumber != null && this.rebateRequest.rebateRequestLoaded.ParentRequestNumber != "" && this.ParentCreationDate != null) {
      ParentNumber = 'Parent Number: ' + this.rebateRequest.rebateRequestLoaded.ParentRequestNumber + ' - ' + this.datepipe.transform(this.ParentCreationDate, 'dd/MM/yyyy');
    }
    if (this.longHaulRequestMeasurementCommitteeAccept != null) {
      DW = this.longHaulRequestMeasurementCommitteeAccept.DW;
      SCNT = this.longHaulRequestMeasurementCommitteeAccept.SCNT;
      NotesAndComments = this.longHaulRequestMeasurementCommitteeAccept.NotesAndComments;


      if (this.longHaulRequestMeasurementCommitteeAccept.RateId != 0 && this.longHaulRequestMeasurementCommitteeAccept.RateId != undefined) {
        let rateID = this.rates.filter(v => v.Id == this.longHaulRequestMeasurementCommitteeAccept.RateId)
        ratelTypeName = rateID[0].NameEN;
      }
      else {
        ratelTypeName = "0";
      }

      if (this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId != 0 && this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId != undefined) {
        let vesselID = this.vesselTypes.filter(v => v.Id == this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId)
        vesselTypeName = vesselID[0].NameEN;
      }
      else {
        vesselTypeName = "0";
      }
    }
    else {

      DW = "0";
      SCNT = "0";
      NotesAndComments = " ";
    }

    let loadedballast = ""
    if (this.rebateRequest.rebateRequestLoaded.IsShipLoaded == true) {
      loadedballast = "Loaded"
    }
    else {
      loadedballast = "Ballast"
    }
    /* let vesselTypeName;
     if (this.rebateRequest.rebateRequestLoaded.VesselTypeId != 0 45979 464 ) {
       let vesselType = this.vesselTypes.filter(v => v.Id == this.rebateRequest.rebateRequestLoaded.VesselTypeId)
       vesselTypeName = vesselType[0].NameEN;
     }
     else {
       vesselTypeName = "0";
     }*/
    var options = [];
    let GrantingDate = "";
    let ETA;
    let DateOfSailing;
    let isSub = false;
    let subsection = [];
    if (this.rebateRequest.rebateRequestLoaded.ParentRequestNumber != null && this.rebateRequest.rebateRequestLoaded.ParentRequestNumber != "" && this.ParentCreationDate != null) {
      isSub = true;
      let subinfo = {

      }
      subsection.push(subinfo);
    }
    this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions.forEach(element => {
      this.getDefineRebateResponse.LongHaulOptionsRebate.forEach(s => {
        GrantingDate = s.CreationDate;
        let portoforigin = "";
        let portofdestination = "";
        let Countryforigin = "";
        let Countrydestination = "";
        if (element.Id == s.Id) {

          if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
            portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN;
          }
          else {
            portoforigin = element.OtherLastPortOrigin;
          }

          if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
            portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN;
          }
          else {
            portofdestination = element.OtherFirstPortDestination;
          }
          // portoforigin = element.LastPortOriginId != null ? this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN : element.OtherLastPortOrigin;
          // portofdestination = element.FirstPortDestinationId != null ? this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN : element.OtherFirstPortDestination;

          Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN : "";
          Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN : "";

          let requestorigin = portoforigin + " - " + Countryforigin;
          let requestdist = portofdestination + " - " + Countrydestination;

          if (element.DateOfSailing.includes('T')) {
            DateOfSailing = this.datepipe.transform(element.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
            ETA = this.datepipe.transform(element.ETA.split("T")[0], 'dd-MM-yyyy');
          }
          else {
            DateOfSailing = element.DateOfSailing;
            ETA = element.ETA;
          }

          let option =
            [{
              alignment: 'center',
              style: 'options',
              columns: [
                {
                  text: element.SuggestedRebate + ' %',
                  style: 'sug'
                },
                {
                  text: requestorigin,
                },
                {
                  text: requestdist,
                },
                {
                  text: s.RebatePercentage + ' %',
                }
              ]
            },
            {
              alignment: 'center',
              style: 'optionss',
              columns: [
                {
                  text: ' ',
                },
                {
                  text: ' ',
                },
                {
                  text: ' ',
                }
              ]
            }

            ]
          options.push(option);
        }
      })
    });
    let Direction = "";
    let SCID = "";
    let ex = "";


    let LTD = ""
    if (this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate != null) {
      LTD = this.datepipe.transform(this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate, 'dd/MM/yyyy');
    }
    else {
      LTD = "None"
    }
    if (this.longHaulRequestMeasurementCommitteeAccept != null) {
      SCID = this.longHaulRequestMeasurementCommitteeAccept.SCID;
    }
    else {
      SCID = "";
    }
    if (this.rebateRequest.rebateRequestLoaded.ExNames != null) {
      ex = this.rebateRequest.rebateRequestLoaded.ExNames;
    }
    else {
      ex = "";
    }

    if (this.longHaulRequestMeasurementCommitteeAccept.DirectionId == 2) {
      Direction = "Northbound";
    }
    else if (this.longHaulRequestMeasurementCommitteeAccept.DirectionId == 3) {
      Direction = "Southbound";
    }
    else {
      Direction = "";
    }
    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },
      content: [
        {
          text: this.rebateRequest.rebateRequestLoaded.RebateFileNumber + ' (LH)',
          style: 'header'
        },
        {
          text: Direction,
          style: 'subheader'
        },
        {
          alignment: 'left',
          style: 'ex',
          columns: [
            {
              text: this.rebateRequest.rebateRequestLoaded.BaseRequest.RequestorName,
            },
            {
              text: '   '
            },

            {
              text: "Principal :  " + this.rebateRequest.rebateRequestLoaded.Name,
            }
          ]
        },
        {
          alignment: 'left',
          style: 'ex',
          columns: [
            {
              text: 'Agent Fax : ' + this.agentFax,
            },
            {
              text: '   '
            },
            {
              text: "Fax :  " + this.rebateRequest.rebateRequestLoaded.Fax + '\n ',
            }
          ]
        },

        {
          alignment: 'left',
          style: 'ex',
          columns: [
            {
              text: 'Request No. : ' + this.rebateRequest.rebateRequestLoaded.BaseRequest.RequestNumber,
            },
            {
              text: '   '
            },
            {
              text: ParentNumber,
            }
          ]
        },


        {
          text: "Mv:  " + this.rebateRequest.rebateRequestLoaded.VesselName,
          style: 'MV'
        },
        {
          text: "Last Transit Date:  " + LTD,
          style: 'LT'
        },
        {
          alignment: 'center',
          style: 'ex',
          columns: [
            {
              text: '\n \n EX.:' + ex + "\n \n",
            },
            {
              text: "",
            }
          ]
        },
        {
          alignment: 'center',
          style: 'ex',
          columns: [
            {
              text: 'SCID: ' + SCID,
            },
            {
              text: 'IMO: ' + this.rebateRequest.rebateRequestLoaded.IMONo + "\n \n \n \n",
            }
          ]
        },
        {
          alignment: 'center',
          style: 'optionsheader',
          columns: [
            {
              text: 'Sug% ',
              style: 'sug'
            },
            {
              text: 'FROM: ',
            },
            {
              text: 'TO: ',
            },
            {
              text: '% ',
            }
          ]
        },
        {
          alignment: 'center',
          style: 'optionsheader',
          columns: [

            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            }
          ]
        },
        options,
        {
          text: "\n \n",
          style: 'subheader'
        },

        {
          style: 'tableExample',
          table: {
            body: [
              ['Submission Date', 'Rebate Granting Date', 'Sailing Date', 'ETA'],
              [this.datepipe.transform(this.rebateRequest.rebateRequestLoaded.BaseRequest.CreationDate, 'dd/MM/yyyy'), this.datepipe.transform(GrantingDate, 'dd/MM/yyyy'), DateOfSailing, ETA]
            ]
          }
        },
        {
          text: "\n",
          style: 'subheader'
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Vessel Type', 'Loaded/Ballast:', 'Cargo Kind', 'Rate', 'Agent Notes'],
              [vesselTypeName, loadedballast, this.rebateRequest.rebateRequestLoaded.CargoKind, ratelTypeName, this.rebateRequest.rebateRequestLoaded.RebateNote]
            ]
          }
        },
        {
          text: "\n",
          style: 'subheader'
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Request Net Tonnage ', 'File SCNT ', 'Request DWT ', "File DWT ", 'Measurement Notes '],
              [this.rebateRequest.rebateRequestLoaded.SCNT, SCNT, this.rebateRequest.rebateRequestLoaded.DWT, DW, NotesAndComments]
            ]
          }
        },
        {
          text: "\n",
          style: 'subheader'
        },
        {
          text: AccurateDataFormRemarks,
          style: 'Remarks'
        },


      ],
      styles: {
        header: {
          font: "Arial",
          fontSize: 26,
          bold: true,
          margin: [0, 0, 0, 5]
        },
        Remarks: {
          font: "Arial",
          fontSize: 12,
          bold: false,
          margin: [0, 10, 0, 5]
        },
        subheader: {
          font: "Arial",
          fontSize: 17,
          bold: false,
          margin: [0, 10, 0, 5]
        },
        MV: {
          fontSize: 38,
          font: "Arial",
          bold: true,
          alignment: 'center'
        },
        LT: {
          font: "Arial",
          fontSize: 12,
          bold: false,
          alignment: 'center'
        },
        center: {
          font: "Arial",
          fontSize: 36,
          bold: true,
          alignment: 'center'
        },
        ex: {
          font: "Arial",
          fontSize: 12,
          bold: false,
          alignment: 'center'
        },
        footer: {
          font: "Arial",
          fontSize: 14,
        },
        optionsheader: {
          font: "Arial",
          bold: true,
          fontSize: 16,
          alignment: 'left'
        },
        sug: {
          font: "Arial",
          bold: true,
          fontSize: 9,
          alignment: 'center'
        },
        options: {
          font: "Arial",
          bold: false,
          fontSize: 12,
          alignment: 'left'
        },
        tableHeader: {
          font: "Arial",
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      },
    }
    pdfMake.fonts = {
      Arial: {
        normal: 'Arial-Regular.ttf',
        bold: 'Arial-Regular.ttf',
        italics: 'Arial-Regular.ttf',
        bolditalics: 'Arial-Regular.ttf'
      }
    },
    pdfMake.createPdf(docDefinition).open();
    ///this.MeasurementExportToPDF();
  }

  exportOptionsDatapdf(e): void {
    e.preventDefault();
    this.exportOptionsDataTOpdf();
  }
  exportOptionsDataTOpdf(): void {
    let vesselTypeName
    if (this.rebateRequest.rebateRequestLoaded.VesselTypeId != 0) {
      let vesselType = this.vesselTypes.filter(v => v.Id == this.rebateRequest.rebateRequestLoaded.VesselTypeId)
      vesselTypeName = vesselType[0].NameEN;
    }
    else {
      vesselTypeName = "0";
    }

    let mvesselTypeName;
    if (this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId != 0) {
      let measurementvesselType = this.vesselTypes.filter(v => v.Id == this.longHaulRequestMeasurementCommitteeAccept.VesselTypeId)
      mvesselTypeName = measurementvesselType[0].NameEN;
    }
    else {
      vesselTypeName = "0";
    }
    let loadedballast = ""
    if (this.rebateRequest.rebateRequestLoaded.IsShipLoaded == true) {
      loadedballast = "Loaded"
    }
    else {
      loadedballast = "Ballast"
    }
    let ratelTypeName;

    if (this.longHaulRequestMeasurementCommitteeAccept.RateId != 0) {
      let rateID = this.rates.filter(v => v.Id == this.longHaulRequestMeasurementCommitteeAccept.RateId)
      ratelTypeName = rateID[0].NameEN;
    }
    else {
      ratelTypeName = "0";
    }
    var options = [];
    this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions.forEach(element => {
      let dateCreated;
      let ETA;
      if (element.DateOfSailing.includes('T')) {
        dateCreated = this.datepipe.transform(element.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
        ETA = this.datepipe.transform(element.ETA.split("T")[0], 'dd-MM-yyyy');
      }
      else {
        dateCreated = element.DateOfSailing;
        ETA = element.ETA;
      }

      let portoforigin = "";
      let portofdestination = "";

      let Countryforigin = "";
      let Countrydestination = "";
      if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
        portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN;
      }
      else {
        portoforigin = element.OtherLastPortOrigin;
      }

      if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
        portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN;
      }
      else {
        portofdestination = element.OtherFirstPortDestination;
      }
      //portoforigin = element.LastPortOriginId != null ? this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN : element.OtherLastPortOrigin;
      //portofdestination = element.FirstPortDestinationId != null ? this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN : element.OtherFirstPortDestination;

      Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN : "";
      Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN : "";

      let requestorigin = portoforigin + " - " + Countryforigin;
      let requestdist = portofdestination + " - " + Countrydestination;
      let option = [
        /*{ text: 'Voyage Calculation',pageBreak: 'before', color: '#7f0909', style: 'sectionHeader' },*/
        { text: 'Voyage Calculation', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Actual Speed', 'Origin:', 'Destination:', 'Distance via Suez:', "Distance via Cape:", "Diff. in Distance:", "Duration via Suez", "Duration via Cape"],
              [element.ActualSpeed, requestorigin, requestdist, element.DistanceMilesSuez, element.DistanceMilesPanama, element.DiffInDistance, element.DurationSuez, element.DurationPanama]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Piracy Cost via Suez : ', 'Piracy Cost via Cape:', 'Daily Bunker Consumption (IFO) in Ton:', 'Bunker Price (IFO)', 'Daily Bunker Consumption (DO) in Ton:', 'Bunker Price (DO):', 'Daily Time Charter'],
              [element.AntiPiracyCostSuez, element.AntiPiracyCostPanama, element.IFOTon, element.IFOTonPrice, element.DOTon, element.DOTonPrice, element.DailyTimeCharter]
            ]
          },
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['SC Tolls:', 'Other SC Charges:', 'Panama Tolls:', 'Other Panama Charges:', 'Cost via Suez:', ' Cost via Cape or Panama:', 'Diff. in Cost:'],
              [element.SCTolls, element.SCOtherCharges, element.PanamaTolls, element.PanamaOtherCharges, element.TotalCostSuez, element.TotalCostPanama, element.DiffInCost]
            ]
          },
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Suggested Rebate (%):', 'Date of Sailing:', 'ETA:'],
              [element.SuggestedRebate, dateCreated, ETA]
            ]
          },
        }, { text: '==============================================================================', color: '#000000', style: 'sectionHeader' }]
      options.push(option);
    });
    let docDefinition = {
      header: 'E-Long Haul Service',
      content: [
        { text: 'Rebate Request Summary', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Request Number:', 'Date:', 'Requester Name:', 'IMO No', 'File Number:'],
              [this.rebateRequest.rebateRequestLoaded.BaseRequest.RequestNumber, this.datepipe.transform(this.rebateRequest.rebateRequestLoaded.BaseRequest.CreationDate, 'dd/MM/yyyy H:mm:ss') + " GMT+2", this.rebateRequest.rebateRequestLoaded.BaseRequest.RequestorName, this.rebateRequest.rebateRequestLoaded.IMONo, this.rebateRequest.rebateRequestLoaded.RebateFileNumber]
            ]
          }
        },
        { text: 'Vessel Particulars', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Name:', 'Ex name:', 'Call Sign:', 'Vessel Type:', 'Year Built:', 'DWT:', 'SCNT:', 'Last transit date:'],
              [this.rebateRequest.rebateRequestLoaded.VesselName, this.rebateRequest.rebateRequestLoaded.ExNames, this.rebateRequest.rebateRequestLoaded.CallSign, vesselTypeName, this.datepipe.transform(this.rebateRequest.rebateRequestLoaded.YearBuilt, 'yyyy'), this.rebateRequest.rebateRequestLoaded.DWT, this.rebateRequest.rebateRequestLoaded.SCNT, this.datepipe.transform(this.rebateRequest.rebateRequestLoaded.LastTransitDate, 'dd/MM/yyyy')]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Capacity in cu. m:', 'Capacity in cu. ft:', 'Max Draught:', 'TRN Draught:', 'Beam:', 'Design Speed:'],
              [this.rebateRequest.rebateRequestLoaded.LPGLNGCapacity, this.rebateRequest.rebateRequestLoaded.ReeferCapacity, this.rebateRequest.rebateRequestLoaded.MAXDraught, this.rebateRequest.rebateRequestLoaded.TRNDraught, this.rebateRequest.rebateRequestLoaded.Beam, this.rebateRequest.rebateRequestLoaded.DesignSpeed]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Scrubber Fitted?', '(IFO) Consumption :', '(DO) Consumption :', 'Loaded/Ballast:', 'Cargo Kind:', 'Cargo Quantity:'],
              [this.rebateRequest.rebateRequestLoaded.IsScrubberFitted, this.rebateRequest.rebateRequestLoaded.FuelIFO, this.rebateRequest.rebateRequestLoaded.FuelDO, loadedballast, this.rebateRequest.rebateRequestLoaded.CargoKind, this.rebateRequest.rebateRequestLoaded.CargoQuantity]
            ]
          }
        },
        { text: 'Measurement Data:', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Rate:', 'Vessel Type:', 'DWT:', 'SCNT:', 'Last transit date:'],
              [ratelTypeName, mvesselTypeName, this.longHaulRequestMeasurementCommitteeAccept.DW, this.longHaulRequestMeasurementCommitteeAccept.SCNT, this.datepipe.transform(this.longHaulRequestMeasurementCommitteeAccept.LastTransitDate, 'dd/MM/yyyy')]
            ]
          }
        },
        {
          style: 'tableExample',
          table: { //Phase3
            body: [
              ['Extra Cost:', 'Measurement Notes :'],
              [this.longHaulRequestMeasurementCommitteeAccept.ExtraCost, this.longHaulRequestMeasurementCommitteeAccept.NotesAndComments]
            ]
          }
        },
        options,
      ],
      styles: {
        header: {
          font: "Arial",
          fontSize: 14,
          bold: true,
          margin: [0, 0, 0, 10]
        },

        tableExample: {
          font: "Arial",
          margin: [0, 5, 0, 15],
          fontSize: 10,
          alignment: 'left'
        },
        tableHeader: {
          font: "Arial",
          bold: true,
          fontSize: 9,
          color: 'black'
        }
      }
    }
    pdfMake.fonts = {
      Arial: {
        normal: 'Arial-Regular.ttf',
        bold: 'Arial-Regular.ttf',
        italics: 'Arial-Regular.ttf',
        bolditalics: 'Arial-Regular.ttf'
      }
    },
    pdfMake.createPdf(docDefinition).open();

  }
  exportOptionsDataExcel(e): void {
    e.preventDefault();
    this.exportOptionsDataToExcel();
  }
  exportOptionsDataToExcel(): void {
    let exportExcelUrl = AppConfig.settings.apiServer.apiUrl + "LongHaul/ExportOptionsDataExcel?longHaulRequestId=" + this.rebateRequestId;
    window.open(exportExcelUrl, '_self');
  }
  later(): void {
    this.router.navigateByUrl('/myTasks');
  }
  getAccurateDataForm(): void {
    this.longHaulService.getAccurateDataForm(this.rebateRequestId).subscribe(
      data => this.getAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getAccurateDataFormCompleted()
    );
  }
  getAccurateDataFormCompleted(): void {
    if (this.getAccurateDataFormResponseObject.Success) {
      this.getAccurateDataFormObject = this.getAccurateDataFormResponseObject.Data as LongHaulRequestAccurateDataForm;
      if (this.getAccurateDataFormObject != null) {
        if (this.getAccurateDataFormObject.DateOfSailing != null || this.getAccurateDataFormObject.PortOfOrigin != "" || this.getAccurateDataFormObject.PortOfDestination != "" || this.getAccurateDataFormObject.SCNT != "" || this.getAccurateDataFormObject.VesselTypeId != null || this.getAccurateDataFormObject.Cargo != "" || this.getAccurateDataFormObject.OtherCharges != "" || this.getAccurateDataFormObject.Deadweight != "" || this.getAccurateDataFormObject.NoOfEscTugs != null || this.getAccurateDataFormObject.NoOfImposedTugs != null || this.getAccurateDataFormObject.Remarks != "") {
          this.accurateDataFormDateOfSailing = this.getAccurateDataFormObject.DateOfSailing != null ? new Date(this.getAccurateDataFormObject.DateOfSailing) : null;
          this.isAccurateDataForm = true;
        }
      }
      this.checkLoading();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  checkLoading(): void {
    this.noOfLoadedLookups++;
    if (this.noOfLoadedLookups == this.noOfLoadingLookups) {
      this.defineRebateLoadedFlag.emit(true);
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
}

enum Decision {
  Accept = 1,
  Reject = 3
}

enum FormMode {
  MeasurementDetailsAccept = 1,
  MeasurementDetailsReject = 2,
  Details = 3,
  DetailsUpdate = 4
}

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
